import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as l, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconListAdd",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, d, _, f, a) {
  return r(), l("svg", {
    "aria-label": d.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--list-add"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "List Add",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    s("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 3a.5.5 0 0 1 .5-.5H8a.5.5 0 1 1 0 1H1.5A.5.5 0 0 1 1 3Zm8 1a.5.5 0 0 1 .5.5v1h1a.5.5 0 1 1 0 1h-1v1a.5.5 0 1 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1A.5.5 0 0 1 9 4ZM1 6a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4A.5.5 0 0 1 1 6Zm0 3a.5.5 0 0 1 .5-.5H8a.5.5 0 1 1 0 1H1.5A.5.5 0 0 1 1 9Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const A = /* @__PURE__ */ o(c, [["render", u]]);
export {
  A as default
};
//# sourceMappingURL=list-add.js.map
